// src/components/auth/Login.jsx - Rebuilt with shadcn components
import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Shield, Mail, ArrowRight, UserPlus } from 'lucide-react';

// Import shadcn components
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { Field, FieldLabel } from '../ui/field';
import { Input, PasswordInput } from '../ui';
import { Alert, AlertDescription } from '../ui/alert';

// Import the real auth context
import { useAuth } from '../../contexts/AuthContext.jsx';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  
  const navigate = useNavigate();
  
  // Use the real auth context instead of local state
  const { login, loading, error } = useAuth();
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Use the real authentication system
    const success = await login(email, password);
    
    if (success) {
      console.log('✅ Login successful, redirecting to dashboard');
      navigate('/dashboard');
    }
    // Error handling is automatically done by AuthContext
  };
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mb-4">
            <Shield className="w-6 h-6 text-white" />
          </div>
          <CardTitle className="text-white">Welcome Back</CardTitle>
          <CardDescription className="text-slate-400">
            Sign in to your business dashboard
          </CardDescription>
        </CardHeader>

        <CardContent>
          {/* Error Display */}
          {error && (
            <Alert variant="destructive" className="mb-6">
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}

          {/* Login Form */}
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Email Field */}
            <Field>
              <FieldLabel htmlFor="email">Email Address *</FieldLabel>
              <Input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                leftIcon={Mail}
                required
                disabled={loading}
              />
            </Field>

            {/* Password Field */}
            <Field>
              <FieldLabel htmlFor="password">Password *</FieldLabel>
              <PasswordInput
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Enter your password"
                required
                disabled={loading}
              />
            </Field>

            {/* Login Button */}
            <Button
              type="submit"
              variant="default"
              className="w-full"
              disabled={!email || !password || loading}
            >
              {loading ? (
                <>
                  <ArrowRight className="mr-2 h-4 w-4 animate-spin" />
                  Signing in...
                </>
              ) : (
                <>
                  Sign In
                  <ArrowRight className="ml-2 h-4 w-4" />
                </>
              )}
            </Button>
          </form>

          {/* Divider */}
          <div className="relative my-6">
            <div className="absolute inset-0 flex items-center">
              <div className="w-full border-t border-slate-700"></div>
            </div>
            <div className="relative flex justify-center text-xs">
              <span className="bg-slate-900/40 px-2 text-slate-400">New partner?</span>
            </div>
          </div>

          {/* New Partner Button */}
          <Button
            asChild
            variant="outline"
            className="w-full"
            disabled={loading}
          >
            <Link to="/partner-signup">
              <UserPlus className="mr-2 h-4 w-4" />
              Join as New Partner
            </Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default Login;